import React from 'react';
import './customerInvoices.scss';

import {Logout,IsRole_Admin,tipoPagamentoOptions,percImponibileRitOptions,percCassaPrevidenzialeOptions} from '../../globals';
import { useAuth } from  '../../contexts/auth'; 

import customerInvoiceDetail from './customerInvoiceDetail.js';

import DataGrid, {
  Column,
 // Export,
  MasterDetail,
  Format,
  //Popup,
  Form,
  Button,
  Pager,
  Paging,
 // FilterRow,
  HeaderFilter,
  Lookup,
  Editing,
  Selection,
  Summary,
  Toolbar,
  //GroupItem,
  TotalItem,
  SearchPanel
} from 'devextreme-react/data-grid';

import FileUploader from 'devextreme-react/file-uploader';
import {Popup} from 'devextreme-react/popup';
import { Button as PopupButton} from 'devextreme-react/button';

//import { TabPanel, Item } from 'devextreme-react/tab-panel';
import { createStore } from 'devextreme-aspnet-data';

import { SimpleItem, GroupItem, Item, TabbedItem, TabPanelOptions, Tab } from 'devextreme-react/form';

import { useState, useEffect, useCallback, useRef} from "react";
import notify from 'devextreme/ui/notify';

import {Button as ToolbarButton} from 'devextreme-react/button';

import { confirm } from 'devextreme/ui/dialog';
import { CheckBox } from 'devextreme-react/check-box';
import { formatNumber } from 'devextreme/localization';

import Query from 'devextreme/data/query';

const updateActionUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaCliente/FileUpload';

const serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaCliente'
const serviceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaClienteRiepilogo'
const serviceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_FattureClienti'
const serviceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaClienteSoggetto'
const serviceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa'

const editorOptions = { readonly: true, format: '###,##0.00'};
const editorOptionsPerc = { readonly: true, format: "#0.00 '%'"};
const notesEditorOptionsLarge = { height: 114, maxLength: 1000};
const notesEditorOptionsSmall = { height: 114, maxLength: 200};

const debug = process.env.ENTITY_DEBUG;

export const numeriRata =  [{id:1,desc: '1'},{id:2,desc: '2'},{id:3,desc: '3'},{id:4,desc: '4'},{id:5,desc: '5'},{id:6,desc: '6'}];

export const tipiFattura =  [{codice:'PR', desc: 'Privati'},{codice:'PA', desc: 'Pubblica Amministrazione'}];

export default function CustomerInvoices(props) {

  const projectId = props.projectId;
  var isInProject = false;
  if (props.isInProject)
    isInProject = props.isInProject;

  const initYear = isInProject? 0:new Date().getFullYear();
  var custInvoiceDataGridRef = React.createRef();

  const [stati, setStati] = useState({});
  const [clienti, setClienti] = useState({});
  const [collaboratori, setCollaboratori] = useState({});
  const [intermediari, setIntermediari] = useState({});
  const [emittentiCedenti, setEmittentiCedenti] = useState({});
  const [tipiSoggetto, setTipiSoggetto] = useState({});
  const [condizioniPagam, setCondizioniPagam] = useState({});
  const [tipoRitenuta, setTipoRitenuta] = useState({});
  const [tipoCassa, setTipoCassa] = useState({});
  const [valute, setValute] = useState({});
  const [modalitaPagam, setModalitaPagam] = useState({});
  const [tipiDocumento, setTipoDocumento] = useState({});
  const [pagamenti, setPagamenti] = useState({});
  const [currentId, setCurrentId] = useState(0);
  const [currentDocNo, setCurrentDocNo] = useState();
  const [currentDocData, setCurrentDocData] = useState();
  const [currentXMLDocNo, setCurrentXMLDocNo] = useState();
  const [currentRow, setCurrentRow] = useState(1);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [isGoToProject, setIsGoToProject] = useState(false);
  const [hasProject, setHasProject] = useState(false);
  const [isToNumber, setIsToNumber] = useState(false);
  const [isToSendSDI, setIsToSendSDI] = useState(false);
  const [isToUpdProceeds, setIsToUpdProceeds] = useState(false);

  const [currentPrj, setCurrentPrj] = useState(0);
  const [currentPrjNo, setCurrentPrjNo] = useState();
  const [isPrjSelected, setIsPrjSelected] = useState(false);

  const [anni, setAnni] = useState({});

  const [annoFilter, setAnnoFilter] = useState(initYear);
  const [clienteFilter, setClienteFilter] = useState();
  const [intermediarioFilter, setIntermediarioFilter] = useState(0);
  const [statoFilter, setStatoFilter] = useState();
  const [isStorico, setIsStorico] = useState(true);

  const [isEditable, setIsEditable] = useState(true);
  const [isCreditNote, setIsCreditNote] = useState(true);
  //const [statiRate, setStatiRate] = useState({});

  const formElement = useRef(null);

  const [isPopupVisible, setPopupVisibility] = useState(false);
  const togglePopup = () => {
    setPopupVisibility(!isPopupVisible);
  };

  const [isPopupVisible2, setPopupVisibility2] = useState(false);
  const togglePopup2 = () => {
    setPopupVisibility2(!isPopupVisible2);
  };

  const { user } = useAuth(); 

  if (!user) 
    Logout();
  
  const isAdmin =IsRole_Admin();

  const filterPayload = { 
    storico: isStorico,
    anno: annoFilter,
    cliente: clienteFilter,
    intermediario: intermediarioFilter,
    stato: statoFilter,
    commessa: projectId,
  };

  //const notesEditorOptions = { height: 38 };

  const remoteDataSource = createStore({

    key: 'id',
    loadUrl: serviceUrl3 + '/Find',
    
    onBeforeSend: (method, ajaxOptions) => {
      if (method === "load" ) {           
        var payload = ajaxOptions.data;
        payload.values = JSON.stringify(filterPayload);
        ajaxOptions.data = payload;          
      }  
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`}   
     ;
    },
    insertUrl: serviceUrl + '/InsertAction',
    updateUrl:serviceUrl + '/UpdateAction',
    deleteUrl: serviceUrl + '/DeleteAction'
    
  });

  const remoteDataSource2 = createStore({

    key: 'id',
    loadUrl: serviceUrl2 + '/FindByFatturaCliente/' + currentId,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    }  
  
    
  });

  const remoteDataSource4 = createStore({

    //  byKey: (key) => {
    //    return fetch(serviceUrl4 + '/FindByOrdineCliente/' + '7');
    //  },
    key: 'id',
    loadUrl: serviceUrl4 + '/FindByFatturaCliente/' + currentId,
    updateUrl:serviceUrl4 + '/UpdateAction',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    }  
    
  });


  function onEditingStart(e) {
    //console.log("EDITING: " + e.key);
    //QUESTO PROVOCA IL DOPPIO REFRESH DEL POPUP DELLA TESTATA
    setCurrentId(e.key);
    //APPROFONDIRE BYKEY
    //dataSource={remoteDataSource4 .byKey(currentRow) .}
  }

  const onEditorPreparing = (e) => {
    if(e.dataField === "clienteId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    if(e.dataField === "destinazioneId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    if(e.dataField === "intermediarioId" && e.parentType ==="dataRow"){
      e.editorOptions.disabled = e.row.data && !(e.row.data.statoId === 1) && e.row.data.statoId != null;
    }
    //può approvare solo admin
    // if(e.dataField === "statoId" && e.parentType ==="dataRow"){
    //   if (!isAdmin && e.row.data.statoId === 7) 
    //     e.editorOptions.disabled = true;
    // }
    if(e.dataField === "clienteId" && e.parentType ==="dataRow"){
      if (!(e.row.data.statoId === 1) || e.row.data.statoId === null)
        setIsEditable(false)
      else
        setIsEditable(true)
    }

    if (e.dataField === 'oggetto' && e.parentType === 'dataRow') {  
      e.editorOptions.maxLength = 200;  
    }  

    //LASCIAMO APERTA LA COMPILAZIONE DELLA SEZIONE DATI FATTURA COLLEGATA
    // if(e.dataField === "numeroFatturaRif" && e.parentType ==="dataRow"){
    //   //console.log("NOTACREDITO: " + e.row.data.tipoDocumentoFiscaleId);
    //   if (e.row.data.tipoDocumentoFiscaleId === 4)
    //   {
    //     //setIsCreditNote(true);
    //     e.editorOptions.disabled = false;
    //     //console.log("ISCREDITONOTE: " +isCreditNote + " - " + e.row.data.tipoDocumentoFiscaleId);
    //   }
    //   else
    //   {
    //     //setIsCreditNote(false);
    //     e.editorOptions.disabled = true;
    //     //console.log("ISCREDITONOTE: " +isCreditNote + " - " + e.row.data.tipoDocumentoFiscaleId);
    //   }
   
    // }
    // if(e.dataField === "dataFatturaRif" && e.parentType ==="dataRow"){
    //   if (e.row.data.tipoDocumentoFiscaleId === 4)
    //     e.editorOptions.disabled = false;
    //   else
    //     e.editorOptions.disabled = true;
    //   //e.editorOptions.visible = e.row.data && (e.row.data.tipoDocumentoFiscaleId === 4)
    //   //e.editorOptions.disable = e.row.data && (e.row.data.tipoDocumentoFiscaleId !== 4)
    // }
    

  }  


  function onRowInserting(e) {
    e.data.ordineId = currentId;
  };

  function onRowValidating(e) {
    //console.log("STATO: " + e.newData.statoId);
    //console.log("NUMERO: " + e.oldData.numero);
    if (e.newData.statoId !== 1 && (e.oldData.numero === null || e.oldData.numero === undefined))
    {
      e.isValid = false;
      e.errorText = "Il documento non può assumere uno stato diverso da Bozza se non viene numerato."
    }

  };

  const remoteDataSource6 = createStore({

    key: 'id',
    loadUrl: serviceUrl6 + '/GetAction',
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = { Authorization: `Bearer ${user.token}`};   
    },
  });

  useEffect(() => {

    const fetchData = async () => {

      const newServiceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaStato';
      var newUrl =  newServiceUrl + "/GetAction";

      const newServiceUrl2 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl2 =  newServiceUrl2 + "/GetClienti";

      const newServiceUrl3 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Collaboratore';
      var newUrl3 =  newServiceUrl3 + "/GetCollaboratori";

      const newServiceUrl4 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Valuta';
      var newUrl4 =  newServiceUrl4 + "/GetAction";

      const newServiceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/ModalitaPagamento';
      var newUrl5 =  newServiceUrl5 + "/GetAction";

      const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CondizioniPagamento';
      var newUrl6 =  newServiceUrl6 + "/GetAction";

      const newServiceUrl7 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl7 =  newServiceUrl7 + "/GetIntermediari";

      const newServiceUrl8 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoSoggetto';
      var newUrl8 =  newServiceUrl8 + "/GetAction";

      const newServiceUrl9 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_AnniFattureClienti';
      var newUrl9 =  newServiceUrl9 + "/GetAction";

      //   const newServiceUrl12 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/RataStato';
      // var newUrl12 =  newServiceUrl12 + "/GetAction";

      const newServiceUrl10 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Anagrafica';
      var newUrl10 =  newServiceUrl10 + "/GetEmittentiCedentiWithDefault";

      const newServiceUrl13 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/View_TipoDocumentiFiscali';
      var newUrl13 =  newServiceUrl13 + "/GetAction";

      const newServiceUrl14 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Pagamento';
      var newUrl14 =  newServiceUrl14 + "/GetAction";

      const newServiceUrl15 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoRitenuta';
      var newUrl15 =  newServiceUrl15 + "/GetWithDefault";

      const newServiceUrl16 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/TipoCassaPrevidenziale';
      var newUrl16 =  newServiceUrl16 + "/GetWithDefault";

      try {

        const requestOptions = {
          headers: {
            Authorization: `Bearer ${user.token}`
          }
        };

        const response = await fetch(newUrl);
        const json = await response.json();
        if (debug === 1)
          console.log(json);
        setStati(json);

        const response2 = await fetch(newUrl2,requestOptions);
        const json2 = await response2.json();
        if (debug === 1)
          console.log(json2);
        setClienti(json2);

        const response3 = await fetch(newUrl3,requestOptions);
        const json3 = await response3.json();
        if (debug === 1)
          console.log(json3);
        setCollaboratori(json3);

        const response4 = await fetch(newUrl4);
        const json4 = await response4.json();
        if (debug === 1)
          console.log(json4);
        setValute(json4);

        const response5 = await fetch(newUrl5);
        const json5 = await response5.json();
        if (debug === 1)
          console.log(json5);
        setModalitaPagam(json5);

        const response6 = await fetch(newUrl6);
        const json6 = await response6.json();
        if (debug === 1)
          console.log(json6);
        setCondizioniPagam(json6);

        const response7 = await fetch(newUrl7,requestOptions);
        const json7 = await response7.json();
        if (debug === 1)
          console.log(json7);
        setIntermediari(json7);

        const response8 = await fetch(newUrl8);
        const json8 = await response8.json();
        if (debug === 1)
         console.log(json8);
        setTipiSoggetto(json8);

        const response9 = await fetch(newUrl9);
        const json9 = await response9.json();
        if (debug === 1)
          console.log(json9);
        setAnni(json9);

        const response10 = await fetch(newUrl10,requestOptions);
        const json10 = await response10.json();
        if (debug === 1)
          console.log(json10);
        setEmittentiCedenti(json10);

        // const response12 = await fetch(newUrl12);
        // const json12 = await response12.json();
        // if (debug === 1)
        //   console.log(json12);
        // setStatiRate(json12);

        const response13 = await fetch(newUrl13);
        const json13 = await response13.json();
        if (debug === 1)
          console.log(json13);
        setTipoDocumento(json13);

        const response14 = await fetch(newUrl14);
        const json14 = await response14.json();
        if (debug === 1)
          console.log(json14);
        setPagamenti(json14);

        const response15 = await fetch(newUrl15);
        const json15 = await response15.json();
        if (debug === 1)
          console.log(json15);
        setTipoRitenuta(json15);

        const response16 = await fetch(newUrl16);
        const json16 = await response16.json();
        if (debug === 1)
          console.log(json16);
        setTipoCassa(json16);

      } catch (error) {
        console.log("error", error);
      }
    };

    fetchData();
  }, []);

  function refreshDataGrid() {
    custInvoiceDataGridRef.instance().refresh();
  }

  function getIntermediarioById(id) {
    return Query(intermediari).filter(['id', id]).toArray()[0];
  }

  const allowedPageSizes = [5, 10, 20];

  function printInvoice(id) {

    const url =  serviceUrl3 + "/CreateFatturaClientePDF/" + id;

    const requestOptions = {
      method: 'POST',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
         Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)

      .then(async (response) => {
        if (!response.ok) {
          throw new Error(`Errore ${response.status}: ${response.statusText}`);
        }
  
        const contentType = response.headers.get("content-type");
        if (!contentType || !contentType.includes("application/pdf")) {
          //const errorText = await response.text();
          const err = await response.json();
          console.log(err.message);
          //throw new Error(`Errore: ${errorText}`);
          //throw new Error(`${errorText}`);
          throw new Error(err.message);
        }
  
        return response.blob();
      })
  


      .then(blob => {

        setTimeout(() => {          
        }, 1500);

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        var slug = "Fattura";

        a.download = slug + ".pdf";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();    
        a.remove();  //afterwards we remove the element again 
        
      })

      .catch(error => { notify(error, 'error', 10000); });

  };  


  function print(e) {
    printInvoice(currentRow);
    notify("Stampa fattura: " + currentDocNo);
  }

  const nuovaNota= (idFattura) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaCliente/CreateCreditNote/' + idFattura;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(detailAllievo),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
    }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        custInvoiceDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  const duplica= (idFattura) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaCliente/Duplicate/' + idFattura;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        custInvoiceDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  function newCreditNote(e) {
    let result = confirm("<i>Procedere con la creazione di una Nota di Credito dalla Fattura corrente?</i>", "Nuova Nota di Credito");
        result.then((dialogResult) => {
          if  (dialogResult) {
            nuovaNota(currentRow);
          }  
        });
  }

  function duplicate(e) {
    let result = confirm("<i>Procedere con la duplicazione della fattura?</i>", "Duplicazione Fattura");
        result.then((dialogResult) => {
          if  (dialogResult) {
            duplica(currentRow);
          }  
        });
  }

  function number(e) {
    let result = confirm("<i>Procedere con la numerazione della fattura?</i>", "Numerazione fattura");
    result.then((dialogResult) => {
      if  (dialogResult) {
        numera(currentRow);
      }  
    });
  };


  const numera= (idFattura) => {
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaCliente/Numera/' + idFattura;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        custInvoiceDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }

  function inviaSDI(idFattura) {
  
    //const url =  serviceUrl4 + "/Download";
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaCliente/SendToSDI/' + idFattura;

    const requestOptions = {
      method: 'POST',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(response => { 
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;             
      })
      .then(data => {
        notify(data.message, data.success ? 'success' : 'error', 6000);
        custInvoiceDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 10000); });

  };  


  function streamXML(idFattura) {

    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaCliente/Download/' + idFattura;

    const requestOptions = {
      method: 'POST',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${user.token}`
      }
    };

    fetch(url, requestOptions)
      .then(response => { 
        if(response.ok) return response.blob();        
        //Global.CheckResponseAuth(response);
      })
      .then(blob => {

        setTimeout(() => {          
        }, 1500);

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        //var slug = "XML_" + idFattura;
        var slug = currentXMLDocNo;

        a.download = slug + ".xml";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();    
        a.remove();  //afterwards we remove the element again 
        
      })

      .catch(error => { notify(error, 'error', 5000); });

  };  

  function createXML(e) {
    //creaXML(currentRow);
    streamXML(currentRow);
  };

  // function checkDataDoc() {
  //   //la data della fattura è inferiore ad oggi
  //   if (currentDocData < new Date())
  //   {
  //     let result = confirm("<i>La data della fattura è inferiore alla data odierna. Procedere comunque?</i>", "Invio a SDI");
  //     result.then((dialogResult) => {
  //       if  (dialogResult)
  //         return true; 
  //       else
  //         return false;
  //     });
  //   }
  //   return true;
  // };

  // function sendToSDI(e) {
  //   if(checkDataDoc)  {
  //     let result = confirm("<i>Procedere con l'invio della fattura al SDI?</i>", "Invio a SDI");
  //     result.then((dialogResult) => {
  //       if  (dialogResult) {
  //         inviaSDI(currentRow);
  //       }  
  //     });
  //   }
  // };

  async function checkDataDoc() {
    // Controlla se la data della fattura è inferiore alla data odierna
    // Normalizza entrambe le date a mezzanotte
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const docDate = new Date(currentDocData);
    docDate.setHours(0, 0, 0, 0);
    //console.log("DATA DOCUMENTO " + docDate);

    if (docDate < today) {
      const result = await confirm(
        "<i>La data della fattura è inferiore alla data odierna. Procedere comunque?</i>",
        "Invio a SDI"
      );
      return result; // true se conferma, false se annulla
    }
    return true;
}

async function sendToSDI(e) {
  // Primo controllo sulla data
  const okData = await checkDataDoc();
  if (!okData) return; // l’utente ha scelto di non proseguire

  // Seconda conferma per l’invio
  const result = await confirm(
    "<i>Procedere con l'invio della fattura al SDI?</i>",
    "Invio a SDI"
  );

  if (result) {
    inviaSDI(currentRow);
    //notify('Invio effettuato', 'success', 2000);
  }
}

  const aggiungiACommessa= () => {

    const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Commessa/AddCustomerInvoiceToProject/' + currentPrj + '/' +currentRow;
  
    const requestOptions = {
      method: 'PUT',
      //body: JSON.stringify(params),
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        return null;
      })
      .then(data => { 
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);    
        }, 100);

      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }


  function addToProject(e) {
    let result = confirm("<i>Aggiungere il documento selezionato alla Commessa " + currentPrjNo + "?</i>", "Aggiungi a Commessa");
        result.then((dialogResult) => {
          if  (dialogResult) {
            aggiungiACommessa();
            setPopupVisibility2(false);
          }  
        });
  }

  function updateMovs() {    
    let result = confirm("<i>Aggiornare gli Incassi della fattura selezionato'?</i>", "Aggiorna Incassi");
      result.then((dialogResult) => {
      if  (dialogResult) {
        aggiornaMovimenti(currentRow);
      }  
    });
  };

  const aggiornaMovimenti= (idFattura) => {
      
    var path = "";
    path = '/api/FatturaCliente/UpdateProceedsMovements/';
    
    const url = process.env.REACT_APP_WEBAPP_DOMAIN + path + idFattura;
  
    const requestOptions = {
      method: 'PUT',
      headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${user.token}`
      }
    };
  
    return fetch(url, requestOptions)
      .then(response => {
        if(response.ok) return response.json();
        //Global.CheckResponseAuth(response);
        return null;
      })
      .then(data => { 
        ;
        setTimeout(() => { 
          notify(data.message, data.success ? 'success' : 'error', 2000);         
        }, 100);
        custInvoiceDataGridRef.instance().refresh();
      })
      .catch(error => { notify(error, 'error', 5000); }); 
  }
 

  function calculateTotale(rowData) {
    return rowData.tipoDocumentoFiscaleId === 4  ? rowData.importoTotale*-1: rowData.importoTotale;
  };
  function calculateImponibile(rowData) {
    return rowData.tipoDocumentoFiscaleId === 4  ? rowData.imponibile*-1: rowData.imponibile;
  };

  function onRowSelectionChanged({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {

      var intermediarioInfo= getIntermediarioById(data.intermediarioId);

      setCurrentRow(data.id);
      setCurrentDocNo(data.numero);
      setCurrentDocData(data.dataDoc);
      setCurrentXMLDocNo("IT" + intermediarioInfo.cf + "_" + data.numero);
      console.log("SELECTED: " + "IT" + intermediarioInfo.cf + "_" + data.numero);
      setIsRowSelected(true);
      if (data.numeroDoc === null)
        setIsToNumber(true)
      else
        setIsToNumber(false)
      //fattura non derivante da ordine oppure nota di credito
      if ((data.refId === null && (data.statoId === 2 || data.statoId === 3)) || (data.tipoDocumentoFiscaleId === 4 && (data.statoId === 2 || data.statoId === 3)))
        setIsToUpdProceeds(true)
      else
        setIsToUpdProceeds(false)

      if (data.numeroDoc !== null && data.statoId === 2)
        setIsToSendSDI(true)
      else
        setIsToSendSDI(false)

      if (data.codiceCommessa !== null)
        setHasProject(true)
      else
        setHasProject(false)


      console.log("SELECTED: " + data.id);
      //setCurrentId(e.currentSelectedRowKeys);

    } else{
      setIsRowSelected(false);
      setIsToNumber(false)
      setIsToUpdProceeds(false)
      setCurrentDocData(null);
    }

    if (data != null && data.statoId > 1)
      setIsGoToProject(true);
    else
      setIsGoToProject(false);
    
  }

  function customizeText(data) {
    return `Fatture: ${data.value}`;
  }

  function customizeData(data) {
    return `${formatNumber(data.value, '###,##0.00')}`;
  }

  const addButtonOptions = {
    icon: 'plus',
    hint: 'Nuova Fattura'
  };

  const selectBoxOptions = {
    width: 150,
    items: anni,
    valueExpr: 'id',
    displayExpr: 'annoDoc',
    onValueChanged: (args) => {
      setAnnoFilter(args.value);
    },
    value: annoFilter
  };
  
  const selectBoxOptions2 = {
    width: 210,
    items: clienti,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Clienti>",
    showClearButton:true,
    searchEnabled:true,
    onValueChanged: (args) => {
      setClienteFilter(args.value);
    },
    value: clienteFilter,
  };

  const selectBoxOptions3 = {
    width: 180,
    items: stati,
    valueExpr: 'id',
    displayExpr: 'nome',
    placeholder:"<Stato>",
    showClearButton:true,
    onValueChanged: (args) => {
      setStatoFilter(args.value);
    },
    value: statoFilter
  };

  const selectBoxOptions4 = {
    width: 210,
    items: intermediari,
    valueExpr: 'id',
    displayExpr: 'ragioneSociale',
    placeholder:"<Azienda>",
    showClearButton:true,
    onValueChanged: (args) => {
      setIntermediarioFilter(args.value);
    },
    value: intermediarioFilter,
  };

  const onCellPrepared = (e) => {
    if (e.rowType === "data") {
        if (e.column.dataField === "statoId") 
        { if (e.data.statoId === 1)
            e.cellElement.style.cssText = "color: white; background-color: #558ea7";
          else if (e.data.statoId === 2)
            e.cellElement.style.cssText = "color: white; background-color: orange";
          else if (e.data.statoId === 3)
            e.cellElement.style.cssText = "color: white; background-color: green";
          else if (e.data.statoId === 4)
            e.cellElement.style.cssText = "color: white; background-color: red";
          else if (e.data.statoId === 5)
            e.cellElement.style.cssText = "color: white; background-color: #E0CF1C";
          else if (e.data.statoId === 6)
            e.cellElement.style.cssText = "color: white; background-color: #1BE02B";
        }
    }
  }

  // const onCellPreparedRate = (e) => {
  //   if (e.rowType === "data") {
  //     if (e.column.dataField === "statoId") 
  //     {  if (e.data.statoId === 1)
  //         e.cellElement.style.cssText = "color: white; background-color: #558ea7";
  //         else if  
  //         (e.data.statoId === 2)
  //         e.cellElement.style.cssText = "color: white; background-color: orange";
  //       else if  
  //       (e.data.statoId === 3)
  //         e.cellElement.style.cssText = "color: white; background-color: green";
  //     }
  //   }
  // }
  
  // function isNotaCreditoGroup(item) {
  //   return item && item.itemType === 'group' && item.caption === 'Nota di Credito';
  // }

  // function isNotaCreditoVisible(dataGridInstance, rowIndex)
  // {
  //   return dataGridInstance.cellValue(rowIndex, 'tipoDocumentoFiscaleId') === 4
  // }



  async function getPayment(id)  {

    if (id == null)
      id = 0;
    
      var serviceUrl = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/Pagamento/GetAction/' + id;

    const requestOptions = {
      method: 'GET',
      //body: JSON.stringify(t),
      headers: {
        'Content-Type': 'application/json',
        //Authorization: `Bearer ${this.state.loggedUser.token}`
      }
    };

    return fetch(serviceUrl, requestOptions)
    .then(response => {
      if(response.ok) return response.json();
      //Global.CheckResponseAuth(response);
      return null;
    })

    .then(data => { 
      return data;
    })
    .catch(error => { notify(error, 'error', 5000); }); 
}

  async function setPaymentValues(newData, value, currentRowData) {

    return getPayment(value).then(data => {
      newData.pagamentoId = value;
      newData.modalitaPagamentoId = data.modalitaPagamentoId;
      newData.condizioniPagamentoId = data.condizioniPagamentoId;
      newData.bancaDescrizione = data.bancaDescrizione;
      newData.iban = data.iban;
 });
}

  function setNCValue(rowData, value) {
    if (value === 4)
      setIsCreditNote(true);
    else
      setIsCreditNote(false);
    this.defaultSetCellValue(rowData, value); 
  };

  const showDeleteButton = useCallback((e) => {
    return (e.row.data.statoId !== 3 & e.row.data.statoId !== 2) || isAdmin;
  }, []);

  const showUpdateButton = useCallback((e) => {
    return e.row.data.statoId !== 3 || e.row.data.master === false || isAdmin;
  }, []);

  const showExportButton = useCallback((e) => {
    return e.row.data.master === false ;
  }, []);


  function cancelAddToProject()  {
    setPopupVisibility2(false);
    setCurrentPrj(0);
    setCurrentPrjNo(0);
    setIsPrjSelected(false);
  };

  function onRowSelectionChangedPrj({ selectedRowsData }) {
    const data = selectedRowsData[0];
    if (data != null) {
      setCurrentPrj(data.id);
      setCurrentPrjNo(data.codice);
      setIsPrjSelected(true);
    } else{
      setCurrentPrj(0);
      setIsPrjSelected(false);
    }
  }

  function onCheckValueChanged(e)  {
    setIsStorico(e.value);
  };

  const onClose = useCallback(() => {
    setPopupVisibility(false);
  }, []);

const renderContent = () => {
  const handleFileUploaded = (e) => {
    if (e.request?.status === 200) {
      const result = JSON.parse(e.request.response);
      if (result.success) {
        notify(result.message, "success", 3000);
        setPopupVisibility(false); // chiudi popup
        custInvoiceDataGridRef.instance().refresh();
      } else {
        notify(result.message, "error", 5000);
      }
    } else {
      notify("Errore sconosciuto durante l'importazione", "error", 5000);
    }
  };

  const handleFileUploadError = () => {
    notify("Errore di rete o server non raggiungibile", "error", 5000);
  };

  return (
    <>
      <form
        id="form"
        ref={formElement}
        method="post"
        action={updateActionUrl}
        encType="multipart/form-data"
      >
        <input type="hidden" id="fatturaId" name="FatturaId" value={currentRow} />

        <FileUploader
          selectButtonText="Seleziona il file da importare"
          labelText=""
          accept=".xml"
          uploadMode="instantly"
          uploadUrl={updateActionUrl}
          uploadHeaders={{ Authorization: `Bearer ${user.token}` }}
          onUploaded={handleFileUploaded}
          onUploadError={handleFileUploadError}
        />

        <div className="upload-popup" align="right">
          <PopupButton
            className="upload-popup-button"
            text="Annulla"
            type="normal"
            onClick={onClose}
          />

        </div>
      </form>
    </>
  );
};



  const renderContent2 = () =>  {
    return (
      <div>

  { isPrjSelected &&
    <p>Aggiungi il documento selezionato alla Commessa <b>{currentPrjNo}</b></p>
  }
     
      <DataGrid id="grid-popup2"
        className={'dx-card wide-card'}
        dataSource={remoteDataSource6}
        showBorders={true}

        focusedRowEnabled={true}
        defaultFocusedRowIndex={0}
        onSelectionChanged={onRowSelectionChangedPrj}
      >
        <Pager
            showPageSizeSelector={false}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
        />
        <Selection mode="single" />
        <Paging defaultPageSize={10} />
       
        <Toolbar>
          <Item location="after">
            <ToolbarButton className="offer-toolbar"
              icon='todo'
              hint='Conferma'
              disabled={!isPrjSelected}
              onClick={addToProject} 
            />
          </Item>
          <Item location="after">
            <ToolbarButton className="offer-toolbar"
              icon='revert'
              hint='Annulla'
              onClick={cancelAddToProject} 
            />
          </Item>    
      
        </Toolbar>
        <Column dataField="id" visible={false}/>
        <Column dataField="codice" caption="Codice" width={110}/>
        <Column dataField="nome" dataType="date" caption="Nome" />
        <Column dataField="clienteId" caption="Cliente" >
          <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
        </Column>
      </DataGrid>
      </div>            
    )
  }



  return (
  <React.Fragment>
    { !isInProject &&  <h2 className={'content-block'}>Fatture Clienti</h2> }
    <div className={'content-block'}>
      <div className={'dx-card responsive-paddings'}>
        
      <DataGrid id="grid-container"
          ref={ref => custInvoiceDataGridRef = ref}
          className={'dx-card wide-card'}
          dataSource={remoteDataSource}
          showBorders={true}

          onSelectionChanged={onRowSelectionChanged}
          //onRowExpanded={onRowExpanded}
          onEditingStart={onEditingStart}
          //onRowRemoving={onRowRemoving}
          onEditorPreparing={onEditorPreparing}
          //onExporting={onExporting}
          onCellPrepared={onCellPrepared}
          //onRowUpdating={onRowUpdating}
          onRowInserting={onRowInserting}
          onRowValidating={onRowValidating}
          dateSerializationFormat= {'yyyy-MM-dd'}
        >
         
         { !isInProject
            &&   
          <Toolbar>
          
            <Item name="addRowButton"  options={addButtonOptions} location="before"/>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='refresh'
                hint='Aggiorna'
                onClick={refreshDataGrid} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='import'
                hint='Importa Fattura Elettronica'
                onClick={togglePopup} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='copy'
                hint='Duplica'
                onClick={duplicate}
                disabled={!isRowSelected} />
            </Item>       
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='inserttable'
                hint='Crea Nota di Credito'
                onClick={newCreditNote}
                disabled={!isRowSelected} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='columnchooser'
                hint='Aggiungi a Commessa'
                onClick={togglePopup2}
                disabled={hasProject} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='hidepanel'
                hint='Aggiorna Incassi'
                onClick={updateMovs} 
                disabled={!hasProject} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='print'
                hint='Stampa'
                onClick={print}
                disabled={!isRowSelected} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='tags'
                hint='Numera'
                onClick={number} 
                disabled={!isToNumber} />
            </Item>       
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='export'
                hint='XML'
                onClick={createXML}
                disabled={!isRowSelected} />
            </Item>
            <Item location="before">
              <ToolbarButton className="offer-toolbar"
                icon='email'
                hint='Invia a SDI'
                onClick={sendToSDI}
                disabled={!isToSendSDI} />
            </Item>
            <Item location="after">
            <CheckBox  
              value={isStorico} onValueChanged={onCheckValueChanged}
              defaultValue={isStorico}
              text="  Storico   "
            >
            </CheckBox>
          </Item>    
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions} >
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions2} >
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions4} >
            </Item>
            <Item location="after"
              locateInMenu="auto"
              widget="dxSelectBox"
              options={selectBoxOptions3} >
            </Item>
            <Item name="searchPanel" className="offer-toolbar"/>
          
          </Toolbar>
          }

          <HeaderFilter visible={true} />
          <Summary>
            <TotalItem
              column="numero"
              summaryType="count"
              customizeText={customizeText}
            />
            <TotalItem
              column="imponibileV"
              summaryType="sum"
              customizeText={customizeData}
            />
          </Summary>
          <Selection mode="single" />

          <Editing
            mode="popup"
            allowUpdating={true}
            allowAdding={!isInProject}
            allowDeleting={true}
            useIcons={true}
          >
          
          <Popup title="Fattura" showTitle={true} width={1200} height={780} />
            <Form>
           
              <Item itemType="group" caption="Dati Identificativi" colCount={4} colSpan={2}>
               
               <Item dataField="tipoFattura" colSpan={2} disabled={false}/>
                <Item dataField="tipoDocumentoFiscaleId" colSpan={2} disabled={false}/>
                <Item dataField="numero" colSpan={2} disabled={true}/>
                <Item dataField="statoId" colSpan={2} isRequired= "true"/>
                <Item dataField="dataDoc" colSpan={2} isRequired= "true"/>
                <Item dataField="dataScadenza" colSpan={2} isRequired= "true"/>
                
                <Item dataField="oggetto"colSpan={4}/>
                <Item dataField="clienteId" colSpan={2} isRequired= "true"/>
                <Item dataField="destinazioneId" colSpan={2} isRequired= "true"/>
                <Item dataField="riferimentoInternoId" colSpan={2} isRequired= "true"/>
                <Item dataField="intermediarioId" colSpan={2} isRequired= "true"/>
                <Item dataField="emittenteId" colSpan={2} />
                <Item dataField="cedenteId" colSpan={2} />
              </Item> 

              <Item itemType="group" caption="Dati Pagamento" colCount={4} colSpan={2}>
                <Item dataField="valutaId" colSpan={2} isRequired= "true"/>
                <Item dataField="tipoPagamento" colSpan={2} isRequired= "true"/>
                <Item dataField="pagamentoId" colSpan={2}/>
                <Item itemType="empty" colSpan={2}/>
                <Item dataField="modalitaPagamentoId" colSpan={2} isRequired= "true"/>
                <Item dataField="condizioniPagamentoId" colSpan={2} isRequired= "true"/>
                <Item dataField="bancaDescrizione" colSpan={2} />
                <Item dataField="iban" colSpan={2} />
                <Item dataField="datiPagamentoInFE" colSpan={2} />
                <Item dataField="bollo" colSpan={2} />  
              </Item>

              <GroupItem caption={"Altri dati gestionali"} colCount={4} colSpan={2} visible={true}>
                <Item dataField="tipoRitenutaId" colSpan={2}  visible={true}/>
                <Item dataField="aliquotaRitenuta"  editorOptions={editorOptionsPerc}/>
                <Item dataField="percImponibileRitenuta"/>
                <Item dataField="causaleRitenuta"colSpan={2}/>
                <Item dataField="importoRitenuta" colSpan={2}editorOptions={editorOptions} disabled={true}/>
             

                <Item dataField="tipoCassaPrevidenzialeId" colSpan={2}  visible={true}/>
                <Item dataField="aliquotaCassaPrevidenziale"  editorOptions={editorOptionsPerc}/>
                <Item dataField="aliquotaIVACassaPrevidenziale"  editorOptions={editorOptionsPerc}/>
                <Item dataField="imponibileCassaPrevidenziale" colSpan={2}editorOptions={editorOptions} />
                <Item dataField="importoCassaPrevidenziale"colSpan={2} disabled={true}/>

               
                <Item dataField="codiceBenestare"colSpan={2}/>
              </GroupItem>


              <GroupItem caption={"Dati fattura collegata"} colCount={4} colSpan={2} visible={true}>
                <Item dataField="numeroFatturaRif"colSpan={2}  visible={true}/>
                <Item dataField="dataFatturaRif"colSpan={2} visible={true}/>
              </GroupItem>

              <GroupItem caption={"Riferimento Ordine Acquisto"} colCount={4} colSpan={2} visible={true}>
                <Item dataField="numeroOrdineRif"colSpan={2}  />
                <Item dataField="dataOrdineRif"colSpan={2} />
                <Item dataField="numItemOrdineRif" colSpan={2}></Item>
                <Item dataField="codiceCommessaFE" colSpan={2}></Item>
                <Item dataField="codiceCUP" colSpan={2}></Item>
                <Item dataField="codiceCIG" colSpan={2}></Item>
              </GroupItem>

              
                <GroupItem caption="Riepilogo" colCount={4} colSpan={2} >
                  <TabbedItem colSpan={4}>
                    <TabPanelOptions deferRendering={false} />
                  
                    <Tab title="Vendita" colCount={3}>
                      <SimpleItem dataField="importoLordo" editorOptions={editorOptions} disabled={true}/>
                      <SimpleItem dataField="percSconto" />
                      <SimpleItem dataField="importoSconto" editorOptions={editorOptions}/>
                  
                      <SimpleItem dataField="imponibile" editorOptions={editorOptions} disabled={true}/>
                      <SimpleItem dataField="imposte" editorOptions={editorOptions} disabled={true}/>
                      <SimpleItem dataField="importoTotale" editorOptions={editorOptions} disabled={true}/>
                    </Tab>
                    <Tab title="Imposte" colCount={3}>
                      <DataGrid id="grid-subcontainer" dataSource={remoteDataSource2}>
                        <Column dataField="id" visible={false}/>
                        <Column dataField="codiceIva"width={80}/>
                        <Column dataField="aliquotaIva"  visible={true}>
                          <Format type="fixedPoint" precision={2} />
                        </Column>
                        <Column dataField="imponibile"  visible={true}>
                          <Format type="fixedPoint" precision={2} />
                        </Column>
                        <Column dataField="imposta"  visible={true}>
                          <Format type="fixedPoint" precision={2} />
                        </Column>
                      </DataGrid>
                    </Tab> 
                    <Tab title="Soggetti" colCount={3}>
                    <DataGrid id="grid-subcontainer2"
                    dataSource={remoteDataSource4}
                    >
                      <Editing
                        mode="form" 
                        allowUpdating={isEditable}
                        useIcons={true}
                      >
                        <Form>
                          <Item dataField="nome"/>
                          <Item dataField="indirizzo"/>
                          <Item dataField="civico"/>
                          <Item dataField="città"/>
                          <Item dataField="provincia"/>
                          <Item dataField="cap"/>
                          <Item dataField="nazione"/>
                          <Item />
                          <Item dataField="piva"/>
                          <Item dataField="cf"/>
                          <Item dataField="codiceDestinatario"/>
                          <Item dataField="pec"/>
                        </Form>
                       </Editing>
                      <Column dataField="id" visible={false}/>
                      <Column dataField="tipoSoggettoId" caption="Tipo" width={120} >
                        <Lookup dataSource={tipiSoggetto} valueExpr="id" displayExpr="nome" />
                      </Column>
                      
                      <Column dataField="nome" width={200}/>
                      <Column dataField="indirizzo" width={200}/>
                      <Column dataField="civico" visible={false}/>
                      <Column dataField="città"/>
                      <Column dataField="provincia" width={80} visible={false}/>
                      <Column dataField="cap" width={80} visible={false} />
                      <Column dataField="nazione" visible={false}/>
                      <Column dataField="piva" width={120}/>
                      <Column dataField="cf" width={150}/>
                      <Column dataField="codiceDestinatario" width={120} caption="Cod. Dest." visible={false} />
                      <Column dataField="pec" width={120} visible={false}/>
                     
                    </DataGrid>
                  </Tab> 


                  </TabbedItem>
                </GroupItem>
                <Item itemType="group" caption="Note" colCount={4} colSpan={2}>
                  <Item 
                      dataField="noteStampa"
                      editorType="dxTextArea"
                      colSpan={2}
                      editorOptions={notesEditorOptionsSmall} />
                  <Item
                      dataField="descrizione"
                      editorType="dxTextArea"
                      colSpan={2}
                      editorOptions={notesEditorOptionsLarge} />
                </Item>

            </Form>
          </Editing>
              

          <Column dataField="id" visible={false}/>
          <Column dataField="numero" caption="Num" width={110}/>
          <Column dataField="numeroDoc" visible={false}/>
          <Column dataField="categoriaDocumento" caption="Tipo" width={110} />
          <Column dataField="dataDoc" dataType="date" format= {'dd/MM/yyyy'} caption="Data doc." />
          <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} caption="Data Scadenza"  />
          <Column dataField="numeroFatturaRif" caption="Numero Rif. Fattura" visible={false}/>
          <Column dataField="dataFatturaRif" caption="Data Rif. Fattura" dataType="date" format= {'dd/MM/yyyy'} visible={false}/>
          <Column dataField="clienteId" caption="Cliente" >
            <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="oggetto" caption="Oggetto" />
      
          <Column dataField="noteStampa" caption="In stampa" visible={false}/>
          <Column dataField="descrizione" caption="Interne" visible={false}/>
          <Column dataField="tipoFattura" caption="Tipo Fattura" visible={false} >
            <Lookup dataSource={tipiFattura} valueExpr="codice" displayExpr="desc" />
          </Column>
          <Column dataField="tipoDocumentoFiscaleId" caption="Tipo Documento"  visible={false} setCellValue={setNCValue}>
            <Lookup dataSource={tipiDocumento} valueExpr="id" displayExpr="descrizioneEstesa" />
          </Column>
          <Column dataField="destinazioneId" caption="Destinatario"  visible={false}>
            <Lookup dataSource={clienti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="riferimentoInternoId" caption="Rif.Interno" >
            <Lookup dataSource={collaboratori} valueExpr="id" displayExpr="cognome" />
          </Column>
          <Column dataField="intermediarioId" caption="Azienda" width={240} visible={false}>
            <Lookup dataSource={intermediari} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="emittenteId" caption="Emittente/Terzo" width={240}  visible={false} editorOptions={{ showClearButton: true }}>
            <Lookup dataSource={emittentiCedenti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="cedenteId" caption="Cedente" width={240}  visible={false} editorOptions={{ showClearButton: true }}>
            <Lookup dataSource={emittentiCedenti} valueExpr="id" displayExpr="ragioneSociale" />
          </Column>
          <Column dataField="importoTotale"  width={100} caption="Totale" visible={false}>
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column name ="imponibileV" caption="Imponibile" calculateCellValue={calculateImponibile} allowEditing={false}>
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column name ="totaleV" caption="Totale" calculateCellValue={calculateTotale} allowEditing={false}>
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="importoLordo" visible={false} >
            <Format type="fixedPoint" precision={2} />
          </Column>
          <Column dataField="percSconto" visible={false} />
          <Column dataField="importoSconto" visible={false} />
          <Column dataField="imponibile" visible={false} />
          <Column dataField="importoScontato" visible={false} />
          <Column dataField="imposte" visible={false} />
          <Column dataField="statoId" caption="Stato" width={110}>
            <Lookup dataSource={stati} valueExpr="id" displayExpr="nome" />
          </Column>
          <Column dataField="valutaId" caption="Valuta" width={80}>
            <Lookup dataSource={valute} valueExpr="id" displayExpr="codice" />
          </Column>
          <Column dataField="datiPagamentoInFE"  visible={false}></Column>
          <Column dataField="tipoPagamento"  visible={false} >
            <Lookup dataSource={tipoPagamentoOptions} displayExpr="desc" valueExpr="id" />
          </Column>
          <Column dataField="bollo" caption="Bollo Virtuale" visible={false} ></Column>
          
          <Column dataField="pagamentoId"  caption="Pagamenti" visible={false} setCellValue={setPaymentValues}>
            <Lookup dataSource={pagamenti} valueExpr="id" displayExpr="nome" />
          </Column>
          <Column dataField="modalitaPagamentoId"  caption="Modalità Pagamento" visible={false}>
            <Lookup dataSource={modalitaPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="condizioniPagamentoId" caption="Condiz. Pagamento" visible={false}>
            <Lookup dataSource={condizioniPagam} valueExpr="id" displayExpr="descrizione" />
          </Column>
          <Column dataField="bancaDescrizione" visible={false} caption="Banca" />
          <Column dataField="iban" visible={false} caption="IBAN"/>

          <Column dataField="codiceCommessa"  caption="Commessa" visible={true} width={90}></Column>

          <Column dataField="tipoRitenutaId" caption="Tipo Ritenuta" visible={false}>
            <Lookup dataSource={tipoRitenuta} valueExpr="id" displayExpr="descrizione" showClearButton={true}/>
          </Column>
          <Column dataField="importoRitenuta" visible={false} />
          <Column dataField="aliquotaRitenuta" visible={false} />
          <Column dataField="causaleRitenuta" visible={false} />
          <Column dataField="percImponibileRitenuta"  visible={false} >
            <Lookup dataSource={percImponibileRitOptions} displayExpr="desc" valueExpr="id" />
          </Column>

          <Column dataField="tipoCassaPrevidenzialeId" caption="Tipo Cassa Previdenziale" visible={false}>
            <Lookup dataSource={tipoCassa} valueExpr="id" displayExpr="descrizione" showClearButton={true}/>
          </Column>
          <Column dataField="importoCassaPrevidenziale"  caption="Importo Cassa" visible={false} />
          <Column dataField="imponibileCassaPrevidenziale" caption="Imponibile Cassa" visible={false} />
          <Column dataField="aliquotaIVACassaPrevidenziale"  caption="Aliquota IVA Cassa" visible={false} />
          <Column dataField="aliquotaCassaPrevidenziale" caption="Aliquota Cassa" visible={false} />

          <Column dataField="numeroOrdineRif" caption="Numero Rif. Ordine" visible={false}/>
          <Column dataField="dataOrdineRif" caption="Data Rif. Ordine" dataType="date" format= {'dd/MM/yyyy'} visible={false}/>
          <Column dataField="numItemOrdineRif"  caption="Item Rif. Ordine" visible={false}></Column>
          <Column dataField="codiceCommessaFE"  visible={false}></Column>
          <Column dataField="codiceCUP"  visible={false}></Column>
          <Column dataField="codiceCIG"  visible={false}></Column>

          <Column dataField="updateBy" visible={false}/>
          <Column dataField="createBy" visible={false}/>
          <Column dataField="refId" visible={false}/>
          <Column dataField="codiceBenestare" visible={false}/>
         
          <Column
            dataField="master"
            caption=""
            
            width={40}
            cellRender={({ data }) => (
              <div style={{ textAlign: 'center' }}>
                {data.master !== true ? (
                  <i className="dx-icon-export" style={{ color: 'green', fontSize: '120%'}} title="Importata" ></i>
                ) : (
                  <></>
                )}
              </div>
            )}
          />

          <Column type="buttons">
            <Button name="edit"  visible={showUpdateButton}/>
            <Button name="delete" visible={showDeleteButton}/>
          </Column>
          <MasterDetail
            enabled={true}
            component={customerInvoiceDetail}
          />
         
        </DataGrid>

        <div>
          <Popup
            width={800}
            height={640} 
            showTitle={true}
            title="Seleziona Commessa"
            visible={isPopupVisible2}
            hideOnOutsideClick={true}
            onHiding={togglePopup2}
            contentRender={renderContent2}
          > 
          </Popup> 
        </div>

        <div>
          <Popup
            width={600}
            height={320} 
            showTitle={true}
            title="Importa fattura elettronica"
            visible={isPopupVisible}
            hideOnOutsideClick={true}
            onHiding={togglePopup}
            contentRender={renderContent}
          > 
          </Popup> 
        </div>

      </div>
    </div>
  </React.Fragment>
  )
};

